import { Input } from "react-ui";
import * as React from "react";
import { useEffect, useState } from "react";

import { Tooltip } from "../../../../Internals/Tooltip/Tooltip";

import { getIndexValidationText } from "./IndexValidation";

interface IndexFieldProps {
    path: string;
    disabled?: boolean;
    error?: string;
    value?: string;
    optional?: boolean;
    skipDefaultValidation?: boolean;
    width?: number;
    "data-tid"?: string;
    onChange: (text: string) => void;
}

export const IndexField = (props: IndexFieldProps) => {
    const [indexError, setIndexError] = useState<string | boolean>(props.error ?? false);

    useEffect(() => {
        if (!props.skipDefaultValidation) {
            setIndexError(getIndexValidationText(props.value ?? "", props.optional));
        }
    }, [props.value]);

    const handleChange = (text: string) => {
        if (!isNaN(Number(text))) {
            props.onChange(text);
        }
    };

    const error = !props.disabled && (props.error || indexError);
    return (
        <Tooltip pos={"top left"} value={error} trigger={Boolean(error) ? "hover&focus" : "closed"}>
            <Input
                error={Boolean(error)}
                value={props.value ?? ""}
                disabled={props.disabled}
                maxLength={6}
                width={props.width ?? 360}
                onValueChange={handleChange}
                data-tid={props["data-tid"] ?? props.path}
            />
        </Tooltip>
    );
};
